// extracted by mini-css-extract-plugin
module.exports = {"MessageBox":"Communication_MessageBox__3bAg4"};